import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Select } from "antd";
import dayjs from "dayjs";
import LicenseOrders from "./license-orders";
import LicenseTariffs from "./license-tariffs";
import LicenseFilter from "./license-filter";
import "./license.css";
import { isMobile } from "@/extensions/design";
import { useState, useEffect, useMemo } from "react";

const License = ({ page }) => {
  const user = useSelector((s) => s.user);
  const navigate = useNavigate();
  const [showFilter, setShowFilter] = useState(false);
  const [filter, setFilter] = useState();

  // Инициализация фильтров из localStorage при монтировании
  useEffect(() => {
    const savedFilter = localStorage.getItem('licenseOrdersFilter');
    if (savedFilter) {
      try {
        setFilter(JSON.parse(savedFilter));
      } catch (e) {
        console.warn('Ошибка при загрузке фильтра из localStorage:', e);
      }
    }
  }, []);

  const normalizeExternalFilter = (extFilter) => {
    if (!extFilter) return null;
    const normalized = { ...extFilter };
    if (normalized.dateFrom && typeof normalized.dateFrom === "string") {
      normalized.dateFrom = dayjs(normalized.dateFrom);
    }
    if (normalized.dateTo && typeof normalized.dateTo === "string") {
      normalized.dateTo = dayjs(normalized.dateTo);
    }
    return normalized;
  };

  const externalFilter = useMemo(() => {
    const normalized = normalizeExternalFilter(filter);
    if (!normalized) return null;
    // На мобильной вёсртке, дочерние компоненты сами управляют фильтрами по датам, т.к. они не входят в модальное окно с доп.фильтрами.
    // Поэтому отправялем только фильтры без дат в externalFilter.
    const { dateFrom, dateTo, ...rest } = normalized;
    return Object.keys(rest).length > 0 ? rest : null;
  }, [filter]);

  const handleFilterClose = (filters) => {
    setShowFilter(false);
    if (filters) setFilter(filters);
  };

  const pages = [
    { title: "Покупки", link: "orders" },
    ...(user.isSuperadmin ? [{ title: "Тарифы", link: "tariffs" }] : []),
  ];

  const handlePageChange = (newPage) => {
    setShowFilter(false);
    navigate(`/license/${newPage}`);
  };

  const getPage = () => {
    switch (page) {
      case "orders": return <LicenseOrders externalFilter={externalFilter}/>;
      case "tariffs": return user.isSuperadmin ? <LicenseTariffs /> : null;
      default: return <LicenseOrders />;
    }
  };

  const getItem = (title, link) => (
    <a 
      className={"col-one-title-item" + (link === page ? " col-one-title-selected " : "")} 
      href={`/license/${link}`}
    >
      {title}
    </a>
  );

  return !isMobile ? (
    <div className="col-one-main">
      <div className="col-one-title">
        {getItem("Покупки", "orders")}
        {user.isSuperadmin && getItem("Тарифы", "tariffs")}
      </div>
      <div className="col-one-col">{getPage()}</div>
    </div>
  ) : (
    <div className="sport-form-content">
      <div className="col-one-main">
        <div className="col-one-col">
          <div style={{ fontWeight: 600, fontSize: 16, margin: 8 }}>Лицензии</div>
          <div className='selector-filer-section'>
            <Select value={page} onChange={handlePageChange} style={{width: "100%"}}>
              {pages.map(p => (
                <Select.Option key={p.link} value={p.link}>
                  {p.title}
                </Select.Option>
              ))}
            </Select>
            {page === "orders" && (
              <div>
                <img src="/images/filter.svg" className="mobile-top-img" alt="filter" onClick={() => setShowFilter(true)}/>
                {showFilter && (
                  <div>
                    <LicenseFilter value={externalFilter} onClose={handleFilterClose}/>
                  </div>
                )}
              </div>
            )}
          </div>
          {getPage()}
        </div>
      </div>
    </div>
  );
};

export default License;